module.exports = __webpack_public_path__ + "img/lunar_coin.566792ca.png";